export default {
    url: '/list',
    template: '<forms-settings-pool-list></forms-settings-pool-list>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/pool/list/index.js